import AdminGiftRequests from "@pages/admin/gift-requests";
import AdminGifts from "@pages/admin/gifts";
import GiftForm from "@pages/admin/gifts/form";
import React from "react";
import Invoices from "@pages/admin/invoices";
import InvoiceDetail from "@pages/admin/invoices/InvoiceDetail";
import EditInvoice from "@pages/admin/invoices/EditInvoice";
import GenerateInvoice from "@pages/admin/invoices/GenerateInvoice";
import CredentialsSettings from "@pages/admin/credentials/CredentialsSettings";
import BillingConfig from "@pages/admin/billing/BillingConfig";
import AiConfiguration from "@pages/admin/ai-configuration/aiConfiguration";
import ManageCompany from "@pages/admin/companies/manageCompany";
import CompanyUsers from "@pages/admin/company-users/companyUsers";
import OAuthConfiguration from "@pages/admin/oauth-configuration/OAuthConfiguration";
import QuickSurveyAdmin from "@pages/admin/quick-surveys";
const SurveyPreview = React.lazy(() => import("@pages/survey/surveyId/preview/index"));


const Adminhome = React.lazy(() => import("@pages/admin/index"));
const GestionUser = React.lazy(() => import("@pages/admin/users/index"));
const GestionSanction = React.lazy(() =>
    import("@pages/admin/sanctions/index")
);

const SurveyCreationMethod = React.lazy(() => import("@pages/survey/new/index"));
const CreateSurveyFromScratch = React.lazy(() => import("@pages/survey/new/scratch/index"));
const SurveySeeder = React.lazy(() => import("@pages/survey/seeder/SurveySeederButton"));
const AISurvey = React.lazy(() => import("@pages/survey/new/ai/index"));
const SurveyAnalyticsPage = React.lazy(() => import("@pages/survey/surveyId/SurveyAnalyticsPage"));

export const adminRoutes = [
  { element: <Adminhome />, index: true },
  {
    path: "/admin/credentials",
    element: <CredentialsSettings />
  },
  { path: "/admin/sanctions", element: <GestionSanction /> },
  { path: "/admin/facturation/configuration", element: <BillingConfig  /> },
  { path: "/admin/users", element: <GestionUser /> },
  {
    path: "/admin/factures",
    element: <Invoices />,
  },
  {
    path: "/admin/factures/:id",
    element: <InvoiceDetail />,
  },
  {
    path: "/admin/factures/:id/edit",
    element: <EditInvoice />,
  },
  {
    path: "/admin/factures/generate",
    element: <GenerateInvoice />,
  },

  {
    path: "/admin/gift-requests",
    element: <AdminGiftRequests />
  },
  {
    path: "/admin/gifts",
    element: <AdminGifts />
  },
  {
    path: "/admin/gifts/new",
    element: <GiftForm />
  },
  {
    path: "/admin/gifts/edit/:id",
    element: <GiftForm />
  },
  {
    path: "/admin/ai",
    element: <AiConfiguration /> },
  {
    path: "/admin/oauth",
    element: <OAuthConfiguration /> },
  {
    path: "/admin/company",
    element: <ManageCompany /> },
  {
    path: "/admin/manage-access",
    element: <CompanyUsers /> },

  { path: "/admin/quick-surveys", element: <QuickSurveyAdmin /> },
  { path: "/admin/quick-surveys/new", element: <SurveyCreationMethod basePath="/admin/quick-surveys/new" /> },
  { path: "/admin/quick-surveys/new/scratch", element: <CreateSurveyFromScratch basePath="/admin/quick-surveys" listPath="/admin/quick-surveys" /> },
  { path: "/admin/quick-surveys/new/simple", element: <SurveySeeder basePath="/admin/quick-surveys" /> },
  { path: "/admin/quick-surveys/new/ai", element: <AISurvey basePath="/admin/quick-surveys/new" /> },
  { path: "/admin/quick-surveys/:surveyId/edit/:stepName", element: <CreateSurveyFromScratch isEditing={true} basePath="/admin/quick-surveys" listPath="/admin/quick-surveys" /> },
  { path: "/admin/quick-surveys/:surveyId/preview", element: <SurveyPreview /> },
  { path: "/admin/quick-surveys/:surveyId/analytics", element: <SurveyAnalyticsPage /> },
];